import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { PageTypeEnum } from 'src/app/shared/models/filter.model';
import { ManipulationsToolbarComponent } from 'src/app/shared/components/manipulations-toolbar/manipulations-toolbar.component';
import { ListsCollectionsComponent } from './components/lists-collections/lists-collections.component';
import { CollectionListsStore } from './store/lists-store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-saved-list',
    imports: [CommonModule, ManipulationsToolbarComponent, ListsCollectionsComponent, TranslateDirective, TranslatePipe],
    providers: [CollectionListsStore, ManipulationsToolbarStore],
    templateUrl: './saved-list.component.html',
    styleUrls: ['./saved-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SavedListComponent {
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);

  ngOnInit(): void {
    this.#manipulationsToolbarStore.updatePageType(PageTypeEnum.SavedLists);
  }
  // ListsCollectionsComponent
}
